export default {
  //capture only logged in assignedSites
  is_logged_in: {
    name: 'Logged In',
    key: 'is_logged_in',
    func: (d) => d.is_logged_in !== false, //don't filter out null values
    showClientOption: true,
  },

  //throw out the annoying zero zero default location pings on the case of a faulty geolocation ping on login
  is_not_zero_zero: {
    name: 'Zero Zero Points',
    key: 'is_not_zero_zero',
    func: (d) => d.longitude !== 0 && d.latitude !== 0,
    showClientOption: false,
  },
};
